import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent {
  isDisabled: boolean = false;
  @Input() Message: string = '';
  @Input() Message2: string = '';
  @Input() Button1: string = 'Ok';
  @Input() Button2: string = 'Close';
  constructor(
    private activeModal: NgbActiveModal,
  ) {}

  close(result:boolean) {
    this.activeModal.close(result);
  }
}
